// src/components/user_selection/UserSelection.js
import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from '../../contexts/UserContext';
import { AuthContext } from '../../contexts/AuthContext';
import RequestService from '../../services/RequestService';
import './UserSelection.css';
import { Box, Typography } from '@mui/material';

const UserSelection = () => {
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { selectUser } = useContext(UserContext);
    const { selectUser: selectUserAuth } = useContext(AuthContext);

    useEffect(() => {
        const fetchAdmins = async () => {
            try {
                const data = await RequestService.getAdmins();
                setAdmins(data);
                setLoading(false);
            } catch (err) {
                setError('Erro ao carregar a lista de administradores.');
                setLoading(false);
            }
        };

        fetchAdmins();
    }, []);

    const handleSelectUser = async (user) => {
        try {
            await selectUserAuth(user.id);
            selectUser(user);
        } catch (error) {
            console.error('Erro ao selecionar o usuário:', error);
        }
    };

    if (loading) {
        return <div className="user-selection-loading">Carregando...</div>;
    }

    if (error) {
        return <div className="user-selection-error">{error}</div>;
    }

    return (
        <div className="user-selection-container">
            <Typography
                sx={{
                    fontFamily: 'Poppins',
                    fontSize: 24,
                    fontWeight: '600',
                    color: '#0C3466',
                    mb: 2,
                }}
            >
                Selecione um Usuário
            </Typography>
            <div className="user-selection-list">
                {admins.map((admin) => (
                    <Box
                        key={admin.id}
                        onClick={() => handleSelectUser(admin)}
                        sx={{
                            padding: 2,
                            borderRadius: 3,
                            border: '2px solid #E0E0E0',
                            '&:hover': {
                                backgroundColor: '#f5f5f5',
                                borderColor: '#1F83FF',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                cursor: 'pointer',
                            },
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: 16,
                                fontWeight: '600',
                                color: '#0C3466',
                            }}
                        >
                            {admin.name}
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: 14,
                                fontWeight: '500',
                                color: '#000000',
                            }}
                        >
                            {admin.company.name}
                        </Typography>
                    </Box>
                ))}
            </div>
        </div>
    );
};

export default UserSelection;
